import { Link } from 'react-router-dom';
import { Linkedin, Twitter } from 'lucide-react';

import styles from './styles/Footer.module.css';

const Footer = () => {
    return (
        <footer className={styles.footer}>
            <div className={styles.footerLinks}>
                <Link to="/terms">Terms of Service</Link>
                <Link to="/privacy">Privacy Policy</Link>
            </div>

            <div className={styles.socialLinks}>
                <a href="https://www.linkedin.com/company/jetchats/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                    <Linkedin size={20} />
                </a>
                <a href="https://x.com/jetchats" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
                    <Twitter size={20} />
                </a>
            </div>

            <div className={styles.copyright}>
                &copy; {new Date().getFullYear()} JetChats. All rights reserved.
            </div>
        </footer>
    );
};

export default Footer;
